import { useSaasHeader } from "@ascend/ui-core/hooks";
import { HeaderKey } from "@ascend/ui-core/types";
import { useEffect, useState } from "react";

import {
  getServiceArtifactUrl,
  addFunctionToWindow,
  removeFunctionFromWindow,
  SaasComponentWindowKeys,
} from "@ascend/ui-core/utils";
import NotificationsDrawer from "./NotificationsDrawer";
import { useApplicationContext } from "../state/ApplicationContext";

declare global {
  interface Window {
    PubSub: typeof import("pubsub-js");
  }
}
const SAAS_HEADER_V2_EVENT = "SaasHeaderV2Connected" as const;

const AscendHeader = () => {
  const [notificationsDrawerOpen, setNotificationsDrawerOpen] = useState(false);

  const HEADER_ELEMENT_ID = "saas-header";
  const utilities = {
    buttons: [
      {
        icon: "NotificationsOutlined",
        onClick: "onClickOpen",
      },
    ],
  };

  const onClickOpen = () => {
    setNotificationsDrawerOpen(true);
  };
  const onClickClose = () => {
    setNotificationsDrawerOpen(false);
  };

  const { service } = useApplicationContext();

  const { initialiseSaasHeader } = useSaasHeader(
    {
      selector: HEADER_ELEMENT_ID,
      title: "Enrich",
      utilities,
    },
    HeaderKey.SAAS_HEADER,
  );

  useEffect(() => {
    if (!service) {
      initialiseSaasHeader(process.env["SAAS_ASSETS_SVC_URL"]!);
    }
  }, [initialiseSaasHeader, service]);

  useEffect(() => {
    addFunctionToWindow(
      "onClickOpen",
      onClickOpen,
      SaasComponentWindowKeys.ExperianSaaSHeaderFunctions,
    );
    return () => {
      removeFunctionFromWindow(
        "onClickOpen",
        SaasComponentWindowKeys.ExperianSaaSHeaderFunctions,
      );
    };
  }, []);

  useEffect(() => {
    const handlePubSubHelp = () => {
      const helpBaseUrl = service ? getServiceArtifactUrl(service) : ".";
      window.PubSub.publish(
        "help.enable",
        `${helpBaseUrl}/contextual-help/Default.htm`,
      );
    };
    window.addEventListener(SAAS_HEADER_V2_EVENT, handlePubSubHelp);
    return () => {
      window.PubSub.publish("help.disable");
      window.removeEventListener(SAAS_HEADER_V2_EVENT, handlePubSubHelp);
    };
  }, [service]);

  return (
    <div data-testid="header-wrapper" id={HEADER_ELEMENT_ID}>
      {notificationsDrawerOpen && (
        <NotificationsDrawer
          isOpen={notificationsDrawerOpen}
          onClickClose={onClickClose}
        />
      )}
    </div>
  );
};

export default AscendHeader;
